import type { PlanCode, PlanLimitsDto } from './dtos';

export const PLAN_DISPLAY_NAME_BY_CODE: Record<PlanCode, string> = {
  trial: 'Trial',
  solo: 'Solo',
  team: 'Team',
};

export const PLAN_DEFAULT_LIMITS_BY_CODE: Record<PlanCode, PlanLimitsDto> = {
  trial: {
    userLimit: 5,
    projectLimit: 3,
    executionLimitMonthly: 1_000,
    executionLimitWeekly: null,
    retentionDays: 14,
    orgLimitPerUser: 1,
  },
  solo: {
    userLimit: 1,
    projectLimit: 1,
    executionLimitMonthly: 2_000,
    executionLimitWeekly: null,
    retentionDays: 90,
    orgLimitPerUser: 1,
  },
  team: {
    userLimit: 5,
    projectLimit: 3,
    executionLimitMonthly: 5_000,
    executionLimitWeekly: null,
    retentionDays: 180,
    orgLimitPerUser: 1,
  },
};

export const PLAN_PRICE_GBP_MINOR_BY_CODE: Record<PlanCode, number> = {
  trial: 0,
  solo: 1900,
  team: 4900,
};

export const getPlanDisplayName = (planCode: PlanCode): string =>
  PLAN_DISPLAY_NAME_BY_CODE[planCode];
